import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { TrendingUp } from 'lucide-react';
import { toast } from 'sonner';
import { API_URL } from '../config/api';

const BACKEND_URL = API_URL;
const API = `${BACKEND_URL}/api`;

const DepotPortefeuilleDialog = ({ open, onClose, portefeuille, onSuccess }) => {
  const [montant, setMontant] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!montant || parseFloat(montant) <= 0) {
      toast.error('Le montant doit être positif');
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        `${API}/portefeuilles/${portefeuille.id}/depot`,
        { montant: parseFloat(montant) },
        { withCredentials: true }
      );
      toast.success('Dépôt effectué !');
      onSuccess();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setMontant('');
    onClose();
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-teal-700">
            <TrendingUp className="h-5 w-5" />
            Faire un dépôt
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="bg-teal-50 border-2 border-teal-200 rounded-xl p-4 text-center">
            <div className="text-sm text-teal-700 mb-1">Solde actuel</div>
            <div className="text-2xl font-bold text-teal-900">{formatCurrency(portefeuille.solde)}</div>
          </div>

          <div>
            <Label htmlFor="montant">Montant (€) *</Label>
            <Input
              id="montant"
              type="number"
              step="0.01"
              value={montant}
              onChange={(e) => setMontant(e.target.value)}
              placeholder="0.00"
              required
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-1">Sera déduit de votre calendrier</p>
          </div>

          {montant && parseFloat(montant) > 0 && (
            <div className="bg-cyan-50 border-2 border-cyan-200 rounded-xl p-4">
              <div className="text-sm text-cyan-700 mb-2">Nouveau solde</div>
              <div className="text-2xl font-bold text-cyan-900">
                {formatCurrency(portefeuille.solde + parseFloat(montant))}
              </div>
            </div>
          )}

          <div className="flex gap-2 pt-2">
            <Button type="button" variant="outline" onClick={handleClose} className="flex-1" disabled={loading}>
              Annuler
            </Button>
            <Button type="submit" className="flex-1 bg-teal-600" disabled={loading}>
              {loading ? 'Dépôt...' : 'Confirmer'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default DepotPortefeuilleDialog;